import { IconsTypesProps } from '../icons/types';

export const Propeler = ({ width = 46, height = 46, fill = '#C9CDCF' }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7448 37.4384C30.9534 37.4384 37.6078 30.784 37.6078 22.5754C37.6078 14.3668 30.9534 7.7124 22.7448 7.7124C14.5362 7.7124 7.88184 14.3668 7.88184 22.5754C7.88184 30.784 14.5362 37.4384 22.7448 37.4384Z"
      fill={fill}
    />
    <path
      d="M22.7836 14.1156V0.533203C22.7836 0.533203 18.0104 2.16308 17.8551 8.13932C15.6044 8.91545 13.5476 10.1961 11.8789 11.9036"
      fill={fill}
    />
    <path
      d="M22.7836 14.1156V0.533203C22.7836 0.533203 18.0104 2.16308 17.8551 8.13932C15.6044 8.91545 13.5476 10.1961 11.8789 11.9036"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M16.7296 16.6769L7.1443 7.09167C7.1443 7.09167 4.93232 11.5933 9.00703 15.9396C7.99805 17.9964 7.49356 20.286 7.49356 22.5756C7.49356 22.6532 7.49356 22.692 7.49356 22.7696"
      fill={fill}
    />
    <path
      d="M16.7296 16.6769L7.1443 7.09167C7.1443 7.09167 4.93232 11.5933 9.00703 15.9396C7.99805 17.9964 7.49356 20.286 7.49356 22.5756C7.49356 22.6532 7.49356 22.692 7.49356 22.7696"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M14.2845 22.7695H0.702148C0.702148 22.7695 2.33203 27.5816 8.38589 27.7368C9.16202 29.9488 10.4815 31.9667 12.1889 33.5966"
      fill={fill}
    />
    <path
      d="M14.2845 22.7695H0.702148C0.702148 22.7695 2.33203 27.5816 8.38589 27.7368C9.16202 29.9488 10.4815 31.9667 12.1889 33.5966"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M16.846 28.8234L7.26074 38.4086C7.26074 38.4086 11.8787 40.6594 16.2639 36.3907C18.2819 37.322 20.4938 37.8265 22.7446 37.8265"
      fill={fill}
    />
    <path
      d="M16.846 28.8234L7.26074 38.4086C7.26074 38.4086 11.8787 40.6594 16.2639 36.3907C18.2819 37.322 20.4938 37.8265 22.7446 37.8265"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M22.9385 31.2682V44.8506C22.9385 44.8506 27.8669 43.1819 27.9057 36.934C30.0401 36.1579 31.9804 34.916 33.5715 33.325"
      fill={fill}
    />
    <path
      d="M22.9385 31.2682V44.8506C22.9385 44.8506 27.8669 43.1819 27.9057 36.934C30.0401 36.1579 31.9804 34.916 33.5715 33.325"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M28.9922 28.7068L38.6163 38.3309C38.6163 38.3309 40.9059 33.6352 36.5207 29.2113C37.5297 27.1545 38.0342 24.8649 38.0342 22.5753"
      fill={fill}
    />
    <path
      d="M28.9922 28.7068L38.6163 38.3309C38.6163 38.3309 40.9059 33.6352 36.5207 29.2113C37.5297 27.1545 38.0342 24.8649 38.0342 22.5753"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M28.8768 16.5603L38.5009 6.97507C38.5009 6.97507 33.9217 4.72428 29.5754 8.91541C27.4798 7.86762 25.1514 7.32434 22.7842 7.32434"
      fill={fill}
    />
    <path
      d="M28.8768 16.5603L38.5009 6.97507C38.5009 6.97507 33.9217 4.72428 29.5754 8.91541C27.4798 7.86762 25.1514 7.32434 22.7842 7.32434"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M22.7448 27.6591C25.5525 27.6591 27.8285 25.383 27.8285 22.5754C27.8285 19.7678 25.5525 17.4917 22.7448 17.4917C19.9372 17.4917 17.6611 19.7678 17.6611 22.5754C17.6611 25.383 19.9372 27.6591 22.7448 27.6591Z"
      fill={fill}
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
    <path
      d="M33.5331 11.7871C35.2018 13.4558 36.4436 15.4349 37.1809 17.6469C43.3512 17.6857 45.0199 22.6142 45.0199 22.6142H31.4375"
      fill={fill}
    />
    <path
      d="M33.5331 11.7871C35.2018 13.4558 36.4436 15.4349 37.1809 17.6469C43.3512 17.6857 45.0199 22.6142 45.0199 22.6142H31.4375"
      stroke="#231F20"
      strokeWidth="0.776135"
      strokeMiterlimit="10"
    />
  </svg>
);
